import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black text-white pt-12 sm:pt-16 pb-6 sm:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-10 sm:mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/a76fc84099da4ca5f9486c73960e2672/739fc27163675d853e3f90f8de30a422.png" 
              alt="LCA Group" 
              className="h-10 sm:h-12 w-auto mb-3 sm:mb-4"
            />
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed mb-4">
              Protecting families and communities through expert environmental consulting since 1996.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <a href="https://www.facebook.com/LCAgroup96/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-900 rounded-lg flex items-center justify-center hover:bg-[#f59e0b] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-base sm:text-lg"></i>
              </a>
              <a href="https://twitter.com/lca_group" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-900 rounded-lg flex items-center justify-center hover:bg-[#f59e0b] transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-base sm:text-lg"></i>
              </a>
              <a href="https://www.linkedin.com/company/lead-consultants-of-america" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-900 rounded-lg flex items-center justify-center hover:bg-[#f59e0b] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-base sm:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Quick Links</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/resources" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/nj-lead-inspections" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  NJ Lead Law
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Services</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/lead-inspections" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  Lead Inspections
                </Link>
              </li>
              <li>
                <Link to="/asbestos-surveys" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  Asbestos Surveys
                </Link>
              </li>
              <li>
                <Link to="/indoor-air-quality" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  Indoor Air Quality
                </Link>
              </li>
              <li>
                <Link to="/abatement-design" onClick={scrollToTop} className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                  Abatement Design
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Corporate Offices</h3>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <div className="text-xs sm:text-sm">
                  <div className="text-[#f59e0b] font-semibold mb-1">Northeast Headquarters</div>
                  <span className="text-gray-400">
                    Somerset, NJ 08873
                  </span>
                </div>
              </li>
              <li>
                <div className="text-xs sm:text-sm">
                  <div className="text-[#f59e0b] font-semibold mb-1">Southeast Office</div>
                  <span className="text-gray-400">
                    Tampa, FL 33602
                  </span>
                </div>
              </li>
              <li className="pt-2 border-t border-gray-900">
                <div className="text-xs sm:text-sm">
                  <div className="text-white font-semibold mb-1">Service Areas</div>
                  <span className="text-gray-400">
                    New Jersey, New York, Pennsylvania, Florida, and nationwide for portfolio clients
                  </span>
                </div>
              </li>
              <li className="flex items-start text-xs sm:text-sm pt-2">
                <i className="ri-phone-line text-[#f59e0b] mr-2 sm:mr-3 mt-1 flex-shrink-0"></i>
                <a href="tel:7324189006" className="text-gray-400 hover:text-[#f59e0b] transition-colors cursor-pointer">
                  (732) 418-9006
                </a>
              </li>
              <li className="flex items-start text-xs sm:text-sm">
                <i className="ri-mail-line text-[#f59e0b] mr-2 sm:mr-3 mt-1 flex-shrink-0"></i>
                <a href="mailto:contact@lcagroup.us" className="text-gray-400 hover:text-[#f59e0b] transition-colors cursor-pointer break-all">
                  contact@lcagroup.us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-900 pt-6 sm:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-xs sm:text-sm text-center md:text-left">
              © 2026 LCA Group. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#f59e0b] transition-colors text-xs sm:text-sm cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
